
// eslint-disable-next-line import/prefer-default-export
import { mapGetters } from 'vuex';

export const listUsers = {
  data: () => ({
    users: [],
    usersSearchObject: {
      page: 0,
      maxPerPage: 10,
      sort: 'givenName,familyName',
    },
    usersLoading: true,
    usersListInfo: {
      totalCount: 0,
    },
  }),
  watch: {
    users() {
      this.usersLoading = false;
    },
  },
  methods: {
    async listUsers() {
      this.usersLoading = true;
      const { data, headers } = await this.$store.dispatch('users/listUsers', this.usersSearchObject);
      if (data) {
        this.users = data;
      }
      this.usersListInfo = this.formatHeaders(headers || {});
    },
    async deleteUser({ id }) {
      this.usersLoading = true;
      const result = await this.$store.dispatch('users/deleteUser', { id });
      return result;
    },
    formatHeaders(headers) {
      return {
        totalCount: Number(headers['x-total-count'] || 0),
      };
    },
  },
};

export const getMe = {
  created() {
    if (this.token) {
      this.$store.dispatch('users/getMe');
    }
  },
  watch: {
    token(newValue) {
      if (newValue) {
        this.$store.dispatch('users/getMe');
      }
    },
  },
  computed: {
    ...mapGetters({
      token: 'authentication/token',
      meDisplayName: 'users/meDisplayName',
    }),
  },
};
